import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';

export const CencoPayPromotionBanner = () => {
  return (
    <div
      className="co-h-[28px] co-w-full lg:co-max-w-300px co-flex  co-bg-cencopay-discount-gradient co-rounded-4px co-border-1 co-border-b-0 co-border-[#FF7C00]"
      tabIndex={0}
    >
      <div className="co-w-full lg:co-max-w-300px co-h-24px co-flex co-bg-white co-gap-8px co-rounded-4px co-items-center co-justify-center">
        <Icon width={24} height={16} icon="CencoCreditCardIcon" />
        <Typography weight="semibold" leading="tight" color="pds-neutral-900">
          Tus descuentos ahora en CencoPay
        </Typography>
      </div>
    </div>
  );
};
